import PropTypes from 'prop-types';

export const Props = {
  /**
   * The visual (svg) used in the loader
   */
  Visual: PropTypes.any,
  /**
   * The theme of the loader
   */
  theme: PropTypes.oneOf([
    'default',
    'alpha',
    'alpha_light',
    'omega',
    'omega_light',
    'white',
    'light',
    'subtle',
    'medium',
    'dark',
    'pitch',
  ]),
  /**
   * If true, the loader is visible and animating
   */
  loading: PropTypes.bool,
  /**
   * If true, the loader will stretch to cover the container (absolute)
   */
  cover: PropTypes.bool,
  /**
   * If true, the loader sit withing the DOM flow of elements (relative)
   */
  inline: PropTypes.bool,
  /**
   * If true, the background-color of the loader will be transparent
   */
  transparent: PropTypes.bool,
  /**
   * If true, the background-color of the loader will be $color-pitch
   */
  pitch: PropTypes.bool,
  /**
   * For CSS customization
   */
  wrpClassName: PropTypes.string,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
